import React from 'react';
import ReactDOM from 'react-dom/client'; // Use `react-dom/client` in React 18
import './index.css';
import App from './App';
import { LanguageProvider } from './LanguageContext';

// Create a root element for rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <LanguageProvider>
            <App />
        </LanguageProvider>
    </React.StrictMode>
);